module.exports = __webpack_public_path__ + "static/media/card-ortho-app.0055ea4c.png";